"use client";

import styles from "./CtaBox.module.css";
import { CtaBox as BumbleCtaBox } from "@bumble/ui-kit";

const stripOuterPTag = (html: string) => html.replace(/^<p>([\s\S]*)<\/p>$/i, "$1").trim();

export default function CtaBox({ data }: any) {
  const { title = "", description = "", button = { text: "", link: "" } } = data;

  return (
    <div className={styles.wrapper}>
      <BumbleCtaBox
        cta={
          button
            ? {
                text: button?.text ?? "",
                href: button?.link ?? "",
                onClick: () => {},
              }
            : undefined
        }
        description={stripOuterPTag(description ?? "")}
        title={title ?? ""}
        align="center"
        isHtml
      />
    </div>
  );
}
